export const EarningsMock = [
  {
    currency: 'USD',
    cusip: '426281101',
    date: '2022-08-16',
    date_confirmed: 1,
    eps: '1.100',
    eps_est: '1.000',
    eps_prior: '1.040',
    eps_surprise: '0.1000',
    eps_surprise_percent: '0.1000',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '611b5ea19803b90001668d61',
    importance: 2,
    isin: 'US4262811015',
    name: 'Jack Henry & Associates',
    notes: '',
    period: 'Q4',
    period_year: 2022,
    revenue: '482672000.000',
    revenue_est: '480120000.000',
    revenue_prior: '450287000.000',
    revenue_surprise: '2552000.0000',
    revenue_surprise_percent: '0.0053',
    revenue_type: 'GAAP',
    ticker: 'JKHY',
    time: '16:00:00',
    updated: 1660682862,
  },
  {
    currency: 'USD',
    cusip: '040334104',
    date: '2022-08-16',
    date_confirmed: 1,
    eps: '-0.450',
    eps_est: '-0.060',
    eps_prior: '-0.550',
    eps_surprise: '-0.3900',
    eps_surprise_percent: '-6.5000',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '6116187b173a1000012a6ab7',
    importance: 1,
    isin: 'US0403341045',
    name: 'Aridis Pharmaceuticals',
    notes: '',
    period: 'Q2',
    period_year: 2022,
    revenue: '292000.000',
    revenue_est: '10460000.000',
    revenue_prior: '33000.000',
    revenue_surprise: '-10168000.0000',
    revenue_surprise_percent: '-0.9721',
    revenue_type: 'GAAP',
    ticker: 'ARDS',
    time: '16:00:00',
    updated: 1660681362,
  },
  {
    currency: 'USD',
    cusip: '040334104',
    date: '2022-05-16',
    date_confirmed: 1,
    eps: '-0.440',
    eps_est: '-0.510',
    eps_prior: '-0.770',
    eps_surprise: '0.0700',
    eps_surprise_percent: '0.1373',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '609b7d01ec342b00015fdb63',
    importance: 1,
    isin: 'US0403341045',
    name: 'Aridis Pharmaceuticals',
    notes: '',
    period: 'Q1',
    period_year: 2022,
    revenue: '1187000.000',
    revenue_est: '2000000.000',
    revenue_prior: '0.000',
    revenue_surprise: '-813000.0000',
    revenue_surprise_percent: '-0.4065',
    revenue_type: 'GAAP',
    ticker: 'ARDS',
    time: '16:00:00',
    updated: 1652739895,
  },
  {
    currency: 'USD',
    cusip: '426281101',
    date: '2022-05-03',
    date_confirmed: 1,
    eps: '1.160',
    eps_est: '1.060',
    eps_prior: '0.950',
    eps_surprise: '0.1000',
    eps_surprise_percent: '0.0943',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '608f9f9de027410001c7a99f',
    importance: 2,
    isin: 'US4262811015',
    name: 'Jack Henry & Associates',
    notes: '',
    period: 'Q3',
    period_year: 2022,
    revenue: '478260000.000',
    revenue_est: '475440000.000',
    revenue_prior: '433776000.000',
    revenue_surprise: '2820000.0000',
    revenue_surprise_percent: '0.0059',
    revenue_type: 'GAAP',
    ticker: 'JKHY',
    time: '16:00:00',
    updated: 1651610555,
  },
  {
    currency: 'USD',
    cusip: '040334104',
    date: '2022-03-31',
    date_confirmed: 1,
    eps: '-0.920',
    eps_est: '-0.410',
    eps_prior: '-0.590',
    eps_surprise: '-0.5100',
    eps_surprise_percent: '-1.2439',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '60656f80de9539000188418a',
    importance: 1,
    isin: 'US0403341045',
    name: 'Aridis Pharmaceuticals',
    notes: '',
    period: 'Q4',
    period_year: 2021,
    revenue: '570000.000',
    revenue_est: '1900000.000',
    revenue_prior: '0.000',
    revenue_surprise: '-1330000.0000',
    revenue_surprise_percent: '-0.7000',
    revenue_type: 'GAAP',
    ticker: 'ARDS',
    time: '17:00:00',
    updated: 1648777247,
  },
  {
    currency: 'USD',
    cusip: '426281101',
    date: '2022-02-08',
    date_confirmed: 1,
    eps: '1.300',
    eps_est: '1.130',
    eps_prior: '0.920',
    eps_surprise: '0.1700',
    eps_surprise_percent: '0.1504',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '6020e1835bf3de00019bd8a1',
    importance: 2,
    isin: 'US4262811015',
    name: 'Jack Henry & Associates',
    notes: '',
    period: 'Q2',
    period_year: 2022,
    revenue: '493896000.000',
    revenue_est: '467970000',
    revenue_prior: '422361000.000',
    revenue_surprise: '25926000.0000',
    revenue_surprise_percent: '0.0554',
    revenue_type: 'GAAP',
    ticker: 'JKHY',
    time: '16:00:00',
    updated: 1644357373,
  },
  {
    currency: 'USD',
    cusip: '040334104',
    date: '2021-11-10',
    date_confirmed: 1,
    eps: '-1.940',
    eps_est: '',
    eps_prior: '-0.650',
    eps_surprise: '',
    eps_surprise_percent: '',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '5fbf528395505d0001cd0370',
    importance: 1,
    isin: 'US0403341045',
    name: 'Aridis Pharmaceuticals',
    notes: '',
    period: 'Q3',
    period_year: 2021,
    revenue: '515000.000',
    revenue_est: '',
    revenue_prior: '0.000',
    revenue_surprise: '',
    revenue_surprise_percent: '',
    revenue_type: 'GAAP',
    ticker: 'ARDS',
    time: '16:00:00',
    updated: 1636554907,
  },
  {
    currency: 'USD',
    cusip: '426281101',
    date: '2021-11-08',
    date_confirmed: 1,
    eps: '1.380',
    eps_est: '1.320',
    eps_prior: '1.190',
    eps_surprise: '0.0600',
    eps_surprise_percent: '0.0455',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '5fbf529b95505d0001cd1752',
    importance: 2,
    isin: 'US4262811015',
    name: 'Jack Henry & Associates',
    notes: '',
    period: 'Q1',
    period_year: 2022,
    revenue: '488056000.000',
    revenue_est: '489350000.000',
    revenue_prior: '451800000.000',
    revenue_surprise: '-1294000.0000',
    revenue_surprise_percent: '-0.0026',
    revenue_type: 'GAAP',
    ticker: 'JKHY',
    time: '16:00:00',
    updated: 1636409053,
  },
  {
    currency: 'USD',
    cusip: '426281101',
    date: '2021-08-17',
    date_confirmed: 1,
    eps: '1.040',
    eps_est: '0.930',
    eps_prior: '0.800',
    eps_surprise: '0.1100',
    eps_surprise_percent: '0.1183',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '5f3b7ca36d76a20001793a87',
    importance: 2,
    isin: 'US4262811015',
    name: 'Jack Henry & Associates',
    notes: '',
    period: 'Q4',
    period_year: 2021,
    revenue: '450287000.000',
    revenue_est: '445120000.000',
    revenue_prior: '410537000.000',
    revenue_surprise: '5167000.0000',
    revenue_surprise_percent: '0.0116',
    revenue_type: 'GAAP',
    ticker: 'JKHY',
    time: '16:00:00',
    updated: 1629231700,
  },
  {
    currency: 'USD',
    cusip: '040334104',
    date: '2021-08-12',
    date_confirmed: 1,
    eps: '-0.550',
    eps_est: '-0.620',
    eps_prior: '-0.470',
    eps_surprise: '0.0700',
    eps_surprise_percent: '0.1129',
    eps_type: 'Adj',
    exchange: 'NASDAQ',
    id: '5f33937db7c159000133e70b',
    importance: 1,
    isin: 'US0403341045',
    name: 'Aridis Pharmaceuticals',
    notes: '',
    period: 'Q2',
    period_year: 2021,
    revenue: '33000.000',
    revenue_est: '300000.000',
    revenue_prior: '1000000.000',
    revenue_surprise: '-267000.0000',
    revenue_surprise_percent: '-0.8900',
    revenue_type: 'GAAP',
    ticker: 'ARDS',
    time: '16:00:00',
    updated: 1628845393,
  },
  {
    currency: 'USD',
    cusip: '040334104',
    date: '2021-05-11',
    date_confirmed: 1,
    eps: '-0.770',
    eps_est: '-0.620',
    eps_prior: '-0.730',
    eps_surprise: '-0.1500',
    eps_surprise_percent: '-0.2419',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '5ebb9afc0f28ed0001709735',
    importance: 1,
    isin: 'US0403341045',
    name: 'Aridis Pharmaceuticals',
    notes: '',
    period: 'Q1',
    period_year: 2021,
    revenue: '0.000',
    revenue_est: '',
    revenue_prior: '0.000',
    revenue_surprise: '',
    revenue_surprise_percent: '',
    revenue_type: 'GAAP',
    ticker: 'ARDS',
    time: '16:00:00',
    updated: 1620803281,
  },
  {
    currency: 'USD',
    cusip: '426281101',
    date: '2021-05-03',
    date_confirmed: 1,
    eps: '0.950',
    eps_est: '0.860',
    eps_prior: '0.960',
    eps_surprise: '0.0900',
    eps_surprise_percent: '0.1047',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '5eafc3a439af700001db26d2',
    importance: 2,
    isin: 'US4262811015',
    name: 'Jack Henry & Associates',
    notes: '',
    period: 'Q3',
    period_year: 2021,
    revenue: '433776000.000',
    revenue_est: '439600000.000',
    revenue_prior: '429406000.000',
    revenue_surprise: '-5824000.0000',
    revenue_surprise_percent: '-0.0132',
    revenue_type: 'GAAP',
    ticker: 'JKHY',
    time: '16:00:00',
    updated: 1620077683,
  },
  {
    currency: 'USD',
    cusip: '040334104',
    date: '2021-03-30',
    date_confirmed: 1,
    eps: '-0.590',
    eps_est: '',
    eps_prior: '-0.620',
    eps_surprise: '',
    eps_surprise_percent: '',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '5e9019850e13ac000141c109',
    importance: 1,
    isin: 'US0403341045',
    name: 'Aridis Pharmaceuticals',
    notes: '',
    period: 'Q4',
    period_year: 2020,
    revenue: '0.000',
    revenue_est: '',
    revenue_prior: '0.000',
    revenue_surprise: '',
    revenue_surprise_percent: '',
    revenue_type: 'GAAP',
    ticker: 'ARDS',
    time: '17:50:00',
    updated: 1617694687,
  },
  {
    currency: 'USD',
    cusip: '426281101',
    date: '2021-02-08',
    date_confirmed: 1,
    eps: '0.920',
    eps_est: '0.870',
    eps_prior: '0.940',
    eps_surprise: '0.0500',
    eps_surprise_percent: '0.0575',
    eps_type: 'Adj',
    exchange: 'NASDAQ',
    id: '5e3916948e5bb20001982c5c',
    importance: 2,
    isin: 'US4262811015',
    name: 'Jack Henry & Associates',
    notes: '',
    period: 'Q2',
    period_year: 2021,
    revenue: '422361000.000',
    revenue_est: '432710000.000',
    revenue_prior: '419119000.000',
    revenue_surprise: '-10349000.0000',
    revenue_surprise_percent: '-0.0239',
    revenue_type: 'GAAP',
    ticker: 'JKHY',
    time: '16:00:00',
    updated: 1612824043,
  },
  {
    currency: 'USD',
    cusip: '040334104',
    date: '2020-11-20',
    date_confirmed: 1,
    eps: '-0.650',
    eps_est: '-0.630',
    eps_prior: '-0.870',
    eps_surprise: '-0.0200',
    eps_surprise_percent: '-0.0317',
    eps_type: 'GAAP',
    exchange: 'NASDAQ',
    id: '5dd2660acef44900019519a0',
    importance: 1,
    isin: 'US0403341045',
    name: 'Aridis Pharmaceuticals',
    notes: '',
    period: 'Q3',
    period_year: 2020,
    revenue: '0.000',
    revenue_est: '310000.000',
    revenue_prior: '0.000',
    revenue_surprise: '-310000.0000',
    revenue_surprise_percent: '-1.0000',
    revenue_type: 'GAAP',
    ticker: 'ARDS',
    time: '16:00:00',
    updated: 1605906898,
  },
];
